export const ANONIMOUS_USER_CODE = '-1002'
export const LOGGED_USER_TYPE = 'R'
export const USER_BIPA_ATTRIBUTE_NAME = 'consentBIPA'
export const USER_BIPA_ACCEPTED_CODE = '1'
